var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotepad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM8.25 15a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2.25a.75.75 0 00-1.5 0V3h-1.5a1.5 1.5 0 00-1.5 1.5v14.25a3 3 0 003 3h10.5a3 3 0 003-3V4.5a1.5 1.5 0 00-1.5-1.5h-1.5v-.75a.75.75 0 00-1.5 0V3h-3v-.75a.75.75 0 00-1.5 0V3h-3v-.75zm7.5 2.25h-3v.75a.75.75 0 01-1.5 0V4.5h-3v.75a.75.75 0 01-1.5 0V4.5h-1.5v14.25a1.5 1.5 0 001.5 1.5h10.5a1.5 1.5 0 001.5-1.5V4.5h-1.5v.75a.75.75 0 01-1.5 0V4.5z",
    fill: "currentColor"
  })));
}
export default SvgNotepad;